import React, { useMemo, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { StyleSettings } from "../../styles/StyleSettings";
import SnForm, { SnFormRef } from "@widgets/SnForm";

interface SnTabProps {
  titles: string[];
  width?: string;
  height?: string;
  header?: React.ReactNode;
  body?: React.ReactNode;
  onTabChanged?: (index: string) => void;
  selectedTab?: any;
  headerInfo?: any[];
}

export function SnTab({
  titles,
  width = "100%",
  height = "100%",
  header,
  body,
  onTabChanged,
  selectedTab,
  headerInfo,
}: SnTabProps) {
  const [value, setValue] = React.useState(selectedTab || "1");

  const headerRefs = useRef<SnFormRef>(null);
  const [haederControls, setFormControls] = useState<any>([]);
  const [headerData, setFormData] = useState<any>(null);

  React.useEffect(() => {
    if (selectedTab) setValue(selectedTab);
  }, [selectedTab]);

  const memoizedHeaders = useMemo(
    () => React.Children.toArray(header),
    [header]
  );
  const memoizedTabs = useMemo(() => React.Children.toArray(body), [body]);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    onTabChanged != null && onTabChanged(newValue);
  };

  return (
    <Box sx={{ width: width, typography: "body1", height: height }}>
      <TabContext value={value}>
        <Box
          sx={{
            height: "35px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            ".MuiTabs-indicator": {
              display: "none", // 인디케이터를 숨김
            },
            ".MuiTabs-root": {
              minHeight: "35px",
              height: "35px",
            },
            ".MuiTab-root": {
              color: "rgb(151, 151, 151)",
              padding: 0,
              "&.Mui-selected": {
                color: "rgb(11, 12, 105)",
              },
            },
          }}
        >
          <TabList onChange={handleChange}>
            {titles.map((title, index) => (
              <Tab
                key={index}
                label={<div className="w-full font-bold">{title}</div>}
                value={`${index + 1}`}
                sx={{
                  fontSize: StyleSettings.font,
                  minHeight: "35px",
                  borderTop: "1px solid rgb(186,191,199)",
                  borderLeft: "1px solid rgb(186,191,199)",
                  borderRight: "1px solid rgb(186,191,199)",
                  borderRadius: "15px 0 0 0",
                }}
                disableRipple
              />
            ))}
          </TabList>
          {!headerInfo && (
            <>
              {memoizedHeaders.map((Header, index) => (
                <Box
                  sx={{
                    // width: 400,
                    display:
                      value === (index + 1).toString() ? "block" : "none",
                  }}
                >
                  {React.isValidElement(Header)
                    ? React.cloneElement(Header)
                    : Header}
                </Box>
              ))}
            </>
          )}
          {headerInfo && <></>}
        </Box>
        {memoizedTabs.map((Tab, index) => (
          <div
            style={{
              display: value === (index + 1).toString() ? "block" : "none",
              height: "calc(100% - 35px)",
              width: "100%",
              flex: 1,
            }}
          >
            {React.isValidElement(Tab) ? React.cloneElement(Tab) : Tab}
          </div>
        ))}
      </TabContext>
    </Box>
  );
}

export default React.memo(SnTab);
